export default {
  path: '/report',
  name: 'report',
  component: () => import('@/layouts/BaseLayout'),
  redirect: '/report/sale-report',
  children: [
    {
      path: 'sale-report',
      meta: { title: '销售报表', permission: 'sale-report' },
      component: () => import('@/views/report/saleReport/index'),
    },
    {
      path: 'purchase-report',
      meta: { title: '采购报表', permission: 'purchase-report' },
      component: () => import('@/views/report/purchaseReport/index'),
    },
    {
      path: 'inventory-report',
      meta: { title: '库存报表', permission: 'inventory-report' },
      component: () => import('@/views/report/stockReport/index'),
    },
    {
      path: 'income-expense-report',
      meta: { title: '收支统计', permission: 'income-expense-report' },
      component: () => import('@/views/report/incomeExpenseStatistics/index'),
    },
    {
      path: 'batch-report',
      meta: { title: '批次报表', permission: 'batch-report' },
      component: () => import('@/views/report/batchReport/index'),
    },
  ],
}